var React = require('react');

function Apple (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"48","height":"48","rx":"24","fill":"white","fillOpacity":"0.1","key":0}),React.createElement("path",{"d":"M30.8306 34.1173C29.603 35.2783 28.2626 35.095 26.9723 34.5451C25.6068 33.9829 24.3541 33.9585 22.9135 34.5451C21.1096 35.3027 20.1575 35.0828 19.0802 34.1173C12.9669 27.9703 13.8689 18.6093 20.8089 18.2671C22.5001 18.3527 23.6776 19.1714 24.6673 19.2448C26.1455 18.9515 27.5611 18.1082 29.1395 18.2182C31.0311 18.3649 32.4592 19.0981 33.3987 20.418C29.4902 22.7032 30.4172 27.7259 34 29.1313C33.286 30.9644 32.3589 32.7853 30.8181 34.1296L30.8306 34.1173ZM24.542 18.1938C24.3541 15.4686 26.6215 13.22 29.2272 13C29.5905 16.1529 26.2958 18.4993 24.542 18.1938Z","fill":"white","fillOpacity":"0.8","key":1})]);
}

Apple.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = Apple;

Apple.default = Apple;
